import { createAction } from 'redux-actions';
export const findPastedDeviation = createAction(`DEVIATION_PASTE.FIND_DEVIATION`, ({ deviationLookup , setEntityData  })=>({
        deviationLookup,
        setEntityData
    }));
